const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    desc: '新番播出后最快同步上线，追更动漫不再等待，让你第一时间看到最新一集。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-stack-line',
    title: '全面覆盖',
    desc: '热血、恋爱、异世界、搞笑、悬疑、治愈全类型番剧，12大分类总有你想追的。',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '电脑、平板、手机全平台支持，追更进度云端同步，随时随地继续观看。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费安全',
    desc: '完全免费无需注册，无广告干扰，安全稳定的追更动漫平台，安心享受每一集。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '追更日历',
    desc: '个性化追更日历，自动标记更新日期，再也不怕错过任何一部连载动漫。',
    color: 'bg-accent-100 text-accent-700',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            樱花动漫之家为你打造最好的追更动漫体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-300 transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.color} mx-auto mb-4`}>
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}